import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useEditMode } from '../../shared/hooks/useEditMode';
import { StyledImgDivContainerProps } from '../../shared/dto/StyleCompRepository';
import { convertS3UrlToCloudFrontUrl } from '../../shared/aws/awsHelper';
import OptimizedMoleculeImgDivContainer from '../../shared/component/molecule/OptimizedMoleculeImgDivContainer';
import { ProjectSimpleData } from '../../shared/dto/EntityRepository';
import ProjectEditControllerForStacked from './ProjectEditControllerForStacked';
import { usePageOwnerIdentityStore } from '../../shared/store/pageOwnerIdentityStore';


interface ProjectSimpleProps {
  data: ProjectSimpleData;
}

const ProjectSimpleStacked: React.FC<ProjectSimpleProps> = ({ data }) => {
  const pageOwner = usePageOwnerIdentityStore(s => s.pageOwner);
  const { isEditMode } = useEditMode();
  const projectDetailPath = pageOwner ? `/@${pageOwner.handle}/projects/${data.id}` : '#';

  const handleProjectLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isEditMode || !pageOwner) {
      e.preventDefault();
    }
  }

  return (
    <ProjectSimpleComp>
      <ContentWrapper to={projectDetailPath} onClick={handleProjectLinkClick} $isPublic={data.isPublic}>
        <OptimizedMoleculeImgDivContainer
          backgroundImg={convertS3UrlToCloudFrontUrl(data.originUrl)}
          StyledImgDivContainer={ProjectRepresent}
          $focusX={data.focusX ?? 0.5}
          $focusY={data.focusY ?? 0.5}
        />
        <ProjectSimpleInfo>
          <ProjectSimpleTitle>
            {data.title}
            <ProjectSimpleYear>{data.projectYear ? `${data.projectYear}` : ''}</ProjectSimpleYear>
          </ProjectSimpleTitle>
        </ProjectSimpleInfo>
      </ContentWrapper>
      <ProjectEditControllerForStacked
        projectId={data.id}
        isPublic={data.isPublic}
      />
    </ProjectSimpleComp>
  );
};

const ProjectSimpleComp = styled.div`
  position: relative;


  width: clamp(600px, 70%, 900px);
  margin-left: 50px;
  margin-bottom: 10px;
  cursor: pointer;
`;

const ContentWrapper = styled(Link)<{ $isPublic: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  color: inherit;
  text-decoration: none;
  ${({ $isPublic }) => !$isPublic && `
    opacity: 0.6;
  `}
`;

const ProjectSimpleInfo = styled.div`
  width: 100%;
  height: 24px;
  display: flex;
  justify-content: start;
  align-items: center;
  overflow: hidden;
`;

const ProjectSimpleTitle = styled.h2`
  text-align: start;
  ${({ theme }) => theme.typography.Body_01_1};
`;

const ProjectSimpleYear = styled.span`
  margin-left: 8px;
  color: ${({ theme }) => theme.colors.color_Gray_05};
  ${({ theme }) => theme.typography.Footer_01};
  font-style: italic;
`;

const ProjectRepresent = styled.div<StyledImgDivContainerProps & {
  $focusX: number;
  $focusY: number;
}>`
  width: 100%;
  height: 42vh;

  background-image: url(${props => props.$backgroundImg});
  background-size: cover;
  background-position: ${({ $focusX, $focusY }) => `${$focusX * 100}% ${$focusY * 100}%`};
  position: relative;
  margin-bottom: 4px;
`;


export default ProjectSimpleStacked;
